import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  content: {
    display: "flex",
    gap: 8,
    width: "100%",
    justifyContent: "space-between",
    padding: theme.spacing.space12,
    alignItems: "center",
    borderRadius: theme.radius.small,
    background: "rgba(34, 34, 34, 0.48)",
    zIndex: 1,
    boxSizing: "border-box",
  },
  contentText: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    justifyContent: "center",
    width: "-webkit-fill-available",
  },
  progressBar: {
    "& > div": {
      margin: "2px !important",
    },
  },
  image: {},
  title: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
}));
